export const PROFILE_COPY = {
  genericError: 'Something went wrong. Please try again.',
  signOut: {
    title: 'Sign Out?',
    body: 'Are you sure you want to sign out of your account?',
    confirm: 'Sign Out',
  },
  editProfile: {
    title: 'Edit Profile',
    saved: 'Profile updated successfully.',
    emailTaken: 'This email address already exists',
    loadError: "We couldn't load your profile. Please try again.",
    changePhone: 'Change phone number',
  },
  changePassword: {
    title: 'Change Password',
    helper: 'Enter your phone number to get a verification code to change your password.',
    resendLabel: 'Resend code',
    newPasswordTitle: 'Change your password',
    newPasswordHelper: 'Create a secure password for your Field Pro account',
    submit: 'Change Password',
    criteria: 'Password does not meet the required criteria',
    mismatch: 'Passwords do not match',
    sameAsCurrent: 'New password must be different from current password',
    updated: 'Password updated successfully.',
  },
  changePhone: {
    title: 'Update Phone Number',
    helper: 'Enter your phone number to get a verification code.',
    newNumberTitle: 'Enter New Phone Number',
    resendLabel: 'Resend OTP',
    newNumber: {
      helper: 'Enter your new phone number to keep your account details up to date.',
      placeholder: 'Enter Phone',
      invalid: 'Enter a valid 10-digit US phone number',
      sameAsCurrent: 'New phone number must be different from the current one',
      alreadyInUse: 'This number is already in use.',
    },
    updated: 'Phone number updated successfully.',
  },
  sendCode: 'Send Code',
  verificationCode: {
    title: 'Enter the 6 Digit Code',
    helper: (last4: string) =>
      `We have sent you a 6-digit code to the phone number ending in ${last4}`,
    label: 'Verification Code',
    verify: 'Verify Code',
  },
  rateLimited: 'Too many attempts try again later.',
} as const;

export const PROFILE_ERROR_CODES = {
  emailAlreadyExists: 'EMAIL_ALREADY_EXISTS',
  validationFailed: 'VALIDATION_FAILED',
  otpVerificationRequired: 'OTP_VERIFICATION_REQUIRED',
  resendRateLimitExceeded: 'RESEND_RATE_LIMIT_EXCEEDED',
  otpExpired: 'OTP_EXPIRED',
  otpSessionNotFound: 'OTP_SESSION_NOT_FOUND',
  otpSessionExpired: 'OTP_SESSION_EXPIRED',
  phoneSameAsCurrent: 'PHONE_SAME_AS_CURRENT',
  phoneAlreadyExists: 'PHONE_ALREADY_EXISTS',
  phoneVerifyRequired: 'PHONE_VERIFY_REQUIRED',
} as const;

/** Grilling Q2: every server-side "this code session is over" lands where the client timer does. */
export const OTP_EXPIRY_CODES: readonly string[] = [
  PROFILE_ERROR_CODES.otpExpired,
  PROFILE_ERROR_CODES.otpSessionNotFound,
  PROFILE_ERROR_CODES.otpSessionExpired,
];
